<template>
    <div>
        <div v-if="claims.auxiliaryRegister.read">
            <!-- {{ entryId }} -->
            <DetailsCard v-if="showDetails"
                         v-model="model">
            </DetailsCard>
        </div>
        <div v-else class="mt-3">
            <div class="text-danger radio-message-danger mt-2">
                <i class="fa fa-exclamation-circle mr-2"></i>
                {{ $t('auxiliary.notAuthorized')}}
            </div>
        </div>
    </div>
</template>

<script>
import DetailsCard from './register/DetailsCard';
import service from '../../services/auxiliaryRegister.service';
import { RegisterFieldValueQueryFilter } from '../../models/enums';
import { mapGetters } from 'vuex';

export default {
    components: {
        DetailsCard
    },
    props: {
        entryId: {
            type: [Number, String],
            required: true
        },
    },
    data() {
        return {
            showDetails: false,
            model: null
        }
    },
    mounted() {
        if (this.entryId) {
            this.load(this.entryId);
        }
    },
    methods: {
        load(entryId) {
            if (!this.claims.auxiliaryRegister.read) {
                return;
            }

            service.getDetails(entryId, RegisterFieldValueQueryFilter.Active)
                .then(response => {
                    if (response.data) {
                        this.model = response.data;
                        this.showDetails = true;
                    }
                })
                .catch(error => {
                    this.model = null;
                    this.showDetails = false;

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration
                    })
                });
        }
    },
    computed: {
        ...mapGetters(['claims'])
    }
}
</script>
